export default "__VITE_ASSET__pGL$Trij__"